import { connect } from 'react-redux';
import Designations from "../../../../components/admin/riaContacts/acordionSections/Designations";

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
  }
}

const DesignationsContainer = connect(mapStateToProps, {})(Designations)

export default DesignationsContainer;